/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Faq_Q4_AnswerInputs */

const en_home_faq_q4_answer = /** @type {(inputs: Home_Faq_Q4_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Once your account is activated, you can access claims support and submit claims digitally where available.`)
};

const fr_home_faq_q4_answer = /** @type {(inputs: Home_Faq_Q4_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui. Une fois votre compte activé, vous pouvez accéder au soutien aux réclamations et soumettre des réclamations numériquement lorsque disponible.`)
};

/**
* | output |
* | --- |
* | "Yes. Once your account is activated, you can access claims support and submit claims digitally where available." |
*
* @param {Home_Faq_Q4_AnswerInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_faq_q4_answer = /** @type {((inputs?: Home_Faq_Q4_AnswerInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Faq_Q4_AnswerInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_faq_q4_answer(inputs)
	return fr_home_faq_q4_answer(inputs)
});